<template>
  <b-card no-body class="mb-50">
    <b-card-header class="pb-50">
      <h5>Tiêu chí</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label class="d-flex justify-content-between">
              <span>Cơ quan sử dụng</span>
              <b-form-checkbox
                v-model="filters.isChildren"
                class="custom-control-primary"
              >
                Cả cơ quan con
              </b-form-checkbox>
            </label>
            <treeselect
              v-on:select="formatDonVis"
              :options="options"
              value-format="object"
              v-model="filters.donVi"
              :clearable="true"
              :searchable="true"
              :show-count="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder=""
          /></b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Trạng thái hồ sơ" label-for="trangthai">
            <v-select
              placeholder=""
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="filters.trangThaiHoSo"
              :reduce="(val) => val.id"
              :options="DM_TRANGTHAIHOSOTIMKIEM"
              label="name"
              :clearable="true"
              input-id="trangthai"
            >
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Loại" label-for="trangthai">
            <v-select
              placeholder=""
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="filters.code"
              :reduce="(val) => val.code"
              :options="DM_LOAI"
              label="name"
              :clearable="true"
              input-id="trangthai"
            >
            </v-select>
          </b-form-group>
        </b-col>
        <!-- <b-col md="12">
          <b-form-group label="Loại" label-for="trangthai">
            <v-select
              placeholder=""
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="filters.code"
              :reduce="(val) => val.id"
              :options="codeList"
              label="name"
              :clearable="true"
              input-id="trangthai"
            >
            </v-select>
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row class="d-flex justify-content-center">
        <b-button
          size="sm"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="primary"
          @click="changeFilter()"
        >
          <feather-icon icon="FileIcon" /> Tải file
        </b-button>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { GetTree } from "@/services/api/DefaultTemplate/DonViService";
import store from "@/store";
import Treeselect from "@riophae/vue-treeselect";
import { PhongBanGetList } from "@/services/api/DefaultTemplate/PhongBanService";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { LoaiBaoCao } from "@/services/api/HoSoCanBoCongChuc/XuatBaoCaoService";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    Treeselect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // define the default value
      value: null,
      filters: {
        isChildren: true,
      },
      listPhongBan: [],
      DM_TRANGTHAIHOSOTIMKIEM: [],
      DM_LOAI: [],
      // codeList: [
      //   { id: 0, code: 'CODE0', name: 'BÁO CÁO TỔNG HỢP SỐ LƯỢNG CÁN BỘ, CÔNG CHỨC TỪ CẤP HUYỆN TRỞ LÊN (Hiện tại chỉ xuất cho 1 đơn vị)' },
      //   { id: 1, code: 'CODE1', name: 'BÁO CÁO SỐ LƯỢNG, CHẤT LƯỢNG ĐỘI NGŨ VIÊN CHỨC (Lĩnh vực Y tế)' },
      //   { id: 2, code: 'CODE2', name: 'BÁO CÁO SỐ LƯỢNG, CHẤT LƯỢNG ĐỘI NGŨ VIÊN CHỨC (Lĩnh vực giáo dục, khoa học công nghệ, khoa học xã hội, văn hóa, thể thao và du lịch và lĩnh vực khác)' },
      //   { id: 3, code: 'CODE3', name: 'BÁO CÁO DANH SÁCH VÀ TIỀN LƯƠNG CÁN BỘ, CÔNG CHỨC TỪ CẤP HUYỆN TRỞ LÊN ' },
      //   { id: 4, code: 'CODE4', name: 'BÁO CÁO DANH SÁCH VÀ TIỀN LƯƠNG VIÊN CHỨC (1 đơn vị)' },
      //   { id: 5, code: 'CODE5', name: 'BÁO CÁO DANH SÁCH VÀ TIỀN LƯƠNG VIÊN CHỨC ' },
      //   // Thêm các code khác
      // ]
    };
  },
  watch: {
    defaultOption() {
      console.log("this.defaultOption", this.defaultOption);
      this.filters.donVi = this.defaultOption;
    },
  },
  created() {
    console.log("LOG ONCREATE : ")
    this.value = JSON.parse(localStorage.getItem("donViFilter"));
    this.filters.donVi = this.value ? this.value : null;
    // console.log("filter", this.filters);

    this.fnGetTrangThaiHoSo();
    this.fnGetLoai();
  },
  methods: {
    fnGetTrangThaiHoSo() {
      this.$store.dispatch("common/fetchTrangThaiHoSoTimKiem",).then((response) => {
        this.DM_TRANGTHAIHOSOTIMKIEM = response;
      });
    },
    fnGetLoai() {
      LoaiBaoCao().then((response) => {
        this.DM_LOAI = response.data;
      });
    },
    formatDonVis(node, instanceId) {},
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },

    changeFilter() {
      // console.log("filter", this.filters);
      this.$emit("fetch-data", this.filters);
      let saveLocal = this.filters.donVi ? this.filters.donVi : null;
      localStorage.setItem("donViFilter", JSON.stringify(saveLocal));
      // console.log("--------------", userData);
    },
  },
  props: {
    defaultOption: {
      type: Object,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

